import { Navigate, Route } from 'react-router';

// Layout
import { PortalPublicLayout } from './shared/components';

// Auth pages
import { PortalLoginPage } from './auth/pages/PortalLoginPage';
import { PortalVerifyPage } from './auth/pages/PortalVerifyPage';
import { ImpersonationHandoffPage } from './auth/pages/ImpersonationHandoffPage';
import { InvestorSelector } from './auth/components/InvestorSelector';
import { ProtectedPortalRoute } from './auth/components/ProtectedPortalRoute';
import { RequireModule } from './auth/components/RequireModule';

// Dashboard
import { PortalDashboardPage } from './dashboard/pages/PortalDashboardPage';

// Holdings
import { PortalHoldingsPage } from './holdings/pages/PortalHoldingsPage';
import { FundDetailPage } from './holdings/pages/FundDetailPage';

// Transactions
import { PortalTransactionsPage } from './transactions/pages/PortalTransactionsPage';
import { DrawdownDetailPage } from './transactions/pages/DrawdownDetailPage';
import { DistributionDetailPage } from './transactions/pages/DistributionDetailPage';

// Carry
import { PortalCarryPage } from './carry/pages/PortalCarryPage';
import { CarryFundDocumentsPage } from './carry/pages/CarryFundDocumentsPage';
import { PortalCarryFundPage } from './carry/pages/PortalCarryFundPage';
import { PortalCarryStakPage } from './carry/pages/PortalCarryStakPage';
import { PortalCarryCooperativePage } from './carry/pages/PortalCarryCooperativePage';
import { PortalCarryHoldingPage } from './carry/pages/PortalCarryHoldingPage';
import { PortalCarryStructureFundPage } from './carry/pages/PortalCarryStructureFundPage';

// Profile
import { PortalProfilePage } from './profile/pages/PortalProfilePage';
import { MyChangeRequestsPage } from './profile/pages/MyChangeRequestsPage';

// Documents
import { PortalDocumentsPage } from './documents/pages/PortalDocumentsPage';

// Emails
import { PortalEmailsPage } from './emails/pages/PortalEmailsPage';
import { EmailDetailPage } from './emails/pages/EmailDetailPage';

export const portalRoutes = [
  // Public Portal Routes (wrapped in public layout with dark theme)
  <Route key="portal-public" element={<PortalPublicLayout />}>
    <Route path="welcome" element={<Navigate to="/" replace />} />
    <Route path="login" element={<PortalLoginPage />} />
    <Route path="auth/verify" element={<PortalVerifyPage />} />
    <Route
      path="auth/impersonation-handoff"
      element={<ImpersonationHandoffPage />}
    />
    <Route path="select-investor" element={<InvestorSelector />} />
  </Route>,

  // Protected Portal Routes (nested under layout)
  // Each route is wrapped with RequireModule to enforce module-level access
  <Route key="portal-protected" element={<ProtectedPortalRoute />}>
    <Route
      index
      element={
        <RequireModule module="dashboard">
          <PortalDashboardPage />
        </RequireModule>
      }
    />
    <Route
      path="holdings"
      element={
        <RequireModule module="holdings">
          <PortalHoldingsPage />
        </RequireModule>
      }
    />
    <Route
      path="holdings/funds/:fundId"
      element={
        <RequireModule module="holdings">
          <FundDetailPage />
        </RequireModule>
      }
    />
    <Route
      path="transactions"
      element={
        <RequireModule module="transactions">
          <PortalTransactionsPage />
        </RequireModule>
      }
    />
    <Route
      path="transactions/drawdowns/:id"
      element={
        <RequireModule module="transactions">
          <DrawdownDetailPage />
        </RequireModule>
      }
    />
    <Route
      path="transactions/distributions/:id"
      element={
        <RequireModule module="transactions">
          <DistributionDetailPage />
        </RequireModule>
      }
    />
    <Route
      path="carry"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryPage />
        </RequireModule>
      }
    />
    <Route
      path="carry/funds/:fundId"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryFundPage />
        </RequireModule>
      }
    />
    <Route
      path="carry/documents/:fundId"
      element={
        <RequireModule module="fund_carry">
          <CarryFundDocumentsPage />
        </RequireModule>
      }
    />
    <Route
      path="carry/structure/stak"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryStakPage />
        </RequireModule>
      }
    />
    <Route
      path="carry/structure/cooperative"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryCooperativePage />
        </RequireModule>
      }
    />
    <Route
      path="carry/structure/holding"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryHoldingPage />
        </RequireModule>
      }
    />
    <Route
      path="carry/structure/funds/:fundId"
      element={
        <RequireModule module="fund_carry">
          <PortalCarryStructureFundPage />
        </RequireModule>
      }
    />
    <Route
      path="documents"
      element={
        <RequireModule module="documents">
          <PortalDocumentsPage />
        </RequireModule>
      }
    />
    <Route
      path="emails"
      element={
        <RequireModule module="documents">
          <PortalEmailsPage />
        </RequireModule>
      }
    />
    <Route
      path="emails/:emailId"
      element={
        <RequireModule module="documents">
          <EmailDetailPage />
        </RequireModule>
      }
    />
    <Route
      path="profile"
      element={
        <RequireModule module="profile">
          <PortalProfilePage />
        </RequireModule>
      }
    />
    <Route
      path="change-data"
      element={
        <RequireModule module="change_data">
          <MyChangeRequestsPage />
        </RequireModule>
      }
    />
  </Route>,
];
